
import { supabase } from '@/lib/supabase';

export interface LivePriceData {
  symbol: string;
  currentPrice: number;
  lastUpdate: Date;
}

export class LivePriceService {
  static async getLivePrice(symbol: string): Promise<{ success: boolean; data?: LivePriceData; error?: string }> {
    try {
      console.log(`Fetching live price for symbol: ${symbol}`);
      
      const { data, error } = await supabase
        .from('tradingview_signals_data')
        .select('message, updated_at')
        .eq('symbol', symbol)
        .eq('timeframe', 'M1')
        .order('updated_at', { ascending: false })
        .limit(1);

      if (error) {
        console.error('Error fetching live price:', error);
        return { success: false, error: error.message };
      }

      if (!data || data.length === 0) {
        console.log(`No price data found for symbol: ${symbol}`);
        return { success: false, error: 'No price data found' };
      }

      const record = data[0];
      if (!record.message || !record.message.price) {
        console.error('Invalid message structure:', record.message);
        return { success: false, error: 'Invalid price data structure' };
      }

      const price = parseFloat(record.message.price);
      if (isNaN(price)) {
        console.error('Invalid price value:', record.message.price);
        return { success: false, error: 'Invalid price data' };
      }

      return {
        success: true,
        data: {
          symbol: symbol,
          currentPrice: price,
          lastUpdate: new Date(record.updated_at)
        }
      };
    } catch (error) {
      console.error('Error in getLivePrice:', error);
      return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
    }
  }
}
